module.exports = __webpack_public_path__ + "static/media/noto-sans-kr-v8-korean-Regular.7b91af55.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/noto-sans-kr/noto-sans-kr-v8-korean-Regular.woff2
// module id = 756
// module chunks = 0